/**
 * <price-total> — line total (unit price × quantity) under the quantity
 * selector, kept in sync with both the quantity input and variant changes.
 * Hidden at quantity 1 (the regular price element already shows the unit
 * price). Works on the PDP and inside the quick-add modal — the element is
 * part of the product-info markup the modal injects, so the definition must
 * be loaded globally (theme.liquid), not from the product section.
 */
if (!customElements.get('price-total')) {
  customElements.define(
    'price-total',
    class PriceTotal extends HTMLElement {
      connectedCallback() {
        this.unitPrice = parseInt(this.dataset.unitPrice, 10) || 0;
        this.valueEl = this.querySelector('[data-price-total-value]');
        this.quantityForm = this.closest('.product-form__quantity');
        try {
          // Shopify liquid money values are subunits (×100 for every
          // currency, zero-decimal ones included) — divide before formatting.
          this.formatter = new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: this.dataset.currency || 'USD',
          });
        } catch (e) {
          this.formatter = null;
        }

        this.onQuantityChange = this.render.bind(this);
        (this.quantityForm || this).addEventListener('change', this.onQuantityChange);

        if (typeof subscribe !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            const productInfo = this.closest('product-info');
            if (!productInfo || event.data.sectionId !== productInfo.dataset.section) return;
            this.unitPrice = event.data.variant ? event.data.variant.price : 0;
            this.render();
          });
          // Fired when quantity rules reset the input (e.g. after add-to-cart).
          this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.onQuantityChange);
        }

        this.render();
      }

      disconnectedCallback() {
        (this.quantityForm || this).removeEventListener('change', this.onQuantityChange);
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
        if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
      }

      get quantity() {
        const input = (this.quantityForm || this).querySelector('.quantity__input');
        const value = input ? parseInt(input.value, 10) : 1;
        return Number.isNaN(value) ? 1 : value;
      }

      render() {
        const quantity = this.quantity;
        if (!this.formatter || !this.valueEl || !this.unitPrice || quantity <= 1) {
          this.hidden = true;
          return;
        }
        this.valueEl.textContent = this.formatter.format((this.unitPrice * quantity) / 100);
        this.hidden = false;
      }
    }
  );
}
